<template>
  <!-- 公司权限管理 -->
  <div class="page_padding">
    <div class="page_content" v-if="authority">
      <div class="head">
        <el-button class="topAn" type="primary" size="mini" plain @click="add">
          <i class="el-icon-plus"></i>
          新增
        </el-button>
        <!-- 筛选 -->
        <div class="screening_box topAn">
          <el-select
            v-model="company_id"
            filterable
            :disabled="!isAdmin"
            placeholder="请选择公司"
            @change="selectCompany"
          >
            <el-option
              :label="company.companyname"
              :value="company.companyid"
              v-for="company in search_companyList"
              :key="company.companyid"
            ></el-option>
          </el-select>
        </div>
      </div>
      <!-- 数量权限配置 -->
      <div id="table_list">
        <el-table
          ref="table"
          v-load="loading"
          :data="tableData"
          style="width: 100%"
          :height="table_height"
        >
          <el-table-column label="公司名称">
            <template slot-scope="scope">
              {{ companyObj[scope.row.companyid] }}
            </template>
          </el-table-column>
          <el-table-column
            prop="classnum"
            label="专题运行数量上限"
          ></el-table-column>
          <el-table-column
            prop="eventexportnum"
            label="专题导出数量上限"
          ></el-table-column>
          <el-table-column prop="pagesize" label="专题翻页数"></el-table-column>
          <el-table-column
            prop="interiorPageSize"
            label="内部专题翻页数"
          ></el-table-column>
          <el-table-column
            prop="principal_num"
            label="主体词数量限制"
          ></el-table-column>
          <el-table-column align="right" label="操作">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleEdit(scope.$index, scope.row)"
              >
                编辑
              </el-button>
              <template>
                <el-popconfirm
                  confirmButtonText="确定"
                  cancelButtonText="取消"
                  :hideIcon="true"
                  title="确定删除吗？"
                  @confirm="confirmDelete"
                >
                  <el-button
                    slot="reference"
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)"
                  >
                    删除
                  </el-button>
                </el-popconfirm>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页器 -->
      <Pagination
        :total="total"
        :list="tableData"
        :page="page"
        :pageSize="pageSize"
        @change="changePage"
      />

      <!-- 添加/编辑数量 -->
      <el-dialog
        :title="title"
        :top="dialog_top"
        :close-on-click-modal="false"
        :visible.sync="dialogFormVisible"
        @close="cancel"
      >
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <!-- 选择公司 -->
          <el-form-item label="公司" prop="companyid" v-if="is_add">
            <el-select
              v-model="add_companyname"
              filterable
              placeholder="请选择公司"
              :disabled="!isAdmin"
              @change="changeSelect"
            >
              <el-option
                :label="company.companyname"
                :value="company.companyid"
                v-for="company in add_companyList"
                :key="company.companyid"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- 名称 -->
          <el-form-item label="专题运行数量上限">
            <el-input
              type="number"
              v-model="ruleForm.classnum"
              placeholder="请输入运行数量"
              clearable
            ></el-input>
          </el-form-item>
          <!-- 专题导出数量上限 -->
          <el-form-item label="专题导出数量上限">
            <el-input
              type="number"
              v-model="ruleForm.eventexportnum"
              placeholder="请输入导出数量"
              clearable
            ></el-input>
          </el-form-item>
          <!-- 专题翻页数 -->
          <el-form-item label="专题翻页数">
            <el-input
              type="number"
              v-model="ruleForm.pagesize"
              placeholder="请输入专题翻页数"
              clearable
            ></el-input>
          </el-form-item>
          <!-- 专题翻页数 -->
          <el-form-item label="内部专题翻页数">
            <el-input
              type="number"
              v-model="ruleForm.interiorPageSize"
              placeholder="请输入专题翻页数"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="主体词限制最大数">
            <el-input-number
              v-model="ruleForm.principal_num"
              placeholder="请输入主体词限制最大数"
              :min="0"
              :max="100"
              :step="1"
              clearable
              step-strictly
            ></el-input-number>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" @click="cancel">取 消</el-button>
          <el-button
            size="mini"
            type="primary"
            :disabled="btn_loading"
            :loading="btn_loading"
            @click="submitForm"
          >
            {{ is_add ? "确 定" : "保 存" }}
          </el-button>
        </div>
      </el-dialog>
    </div>
    <div class="null_page" v-else>没有操作权限</div>
  </div>
</template>

<script>
import mixins from "../../../mixins";

export default {
  mixins: [mixins],
  data() {
    return {
      dialogFormVisible: false,
      is_add: true,
      // 表单
      ruleForm: {
        classnum: "",
        eventexportnum: "",
        pagesize: "",
        interiorPageSize: "",
        principal_num: "5"
      },
      // 表单检验规则
      rules: {
        classnum: [
          { required: true, message: "请输入运行数量", trigger: "blur" }
        ],
        eventexportnum: [
          { required: true, message: "请输入导出数量", trigger: "blur" }
        ],
        pagesize: [
          { required: true, message: "请输入专题翻页数", trigger: "blur" }
        ],
        principal_num: [
          {
            required: true,
            message: "请输入主体词最大数量限制",
            trigger: "blur"
          }
        ]
      },
      row_index: 0,
      dialog_top: "5vh",
      is_init: false,
      companyObj: {},
      company_list: [],
      search_companyList: [],
      add_companyList: [],
      add_companyname: "",
      company_id: "",
      id: "",
      title: "",
      btn_loading: false
    };
  },
  computed: {
    isAdmin() {
      return this.$store.state.isAdmin;
    },
    companyId() {
      return this.$store.state.companyId;
    }
  },
  created() {
    this.getCompanyList();
  },
  methods: {
    // 获取列表
    getList() {
      if (!this.authority) return;
      this.loading = true;
      this.tableScrollTop();
      if (!this.isAdmin) this.company_id = this.companyId;
      this.$http({
        url: this.$api.num_list,
        data: {
          companyid: this.company_id,
          pageIndex: this.page,
          pageSize: this.pageSize
        }
      }).then(res => {
        this.loading = false;
        this.is_init = false;
        if (res.code == 0) {
          this.total = res.data.total;
          this.tableData = res.data.concent;
        }
      });
    },
    // 获取公司列表
    getCompanyList() {
      this.$http({
        url: this.$api.company_list
      }).then(res => {
        if (res.code == 0) {
          this.companyObj = {};
          res.data.forEach(val => {
            this.companyObj[val.companyid] = val.companyname;
          });
          if (this.isAdmin) {
            this.company_list = res.data;
            this.add_companyList = [...res.data];
            this.search_companyList = res.data;
            this.search_companyList.unshift({
              companyid: "0",
              companyname: "全部"
            });
          } else {
            res.data.forEach(val => {
              if (val.companyid == this.companyId) {
                this.company_list = [val];
                this.add_companyList = [val];
                this.search_companyList = [val];
              }
            });
          }
        }
      });
    },
    // 筛选公司
    selectCompany(e) {
      e == "0" ? (this.company_id = "") : (this.company_id = e);
      this.page = 1;
      this.getList();
    },
    // 新增
    addNumReq(data) {
      this.btn_loading = true;
      this.$http({
        url: this.$api.add_num,
        data
      }).then(res => {
        this.btn_loading = false;
        if (res.code == 0) {
          this.is_init = true;
          this.page = 1;
          this.getList();
          this.cancel();
          this.$hint("添加成功");
        } else {
          this.$hint(res.message, "err");
        }
      });
    },
    // 编辑
    editNumReq(data) {
      this.btn_loading = true;
      this.$http({
        url: this.$api.edit_num,
        data
      }).then(res => {
        this.btn_loading = false;
        if (res.code == 0) {
          this.$set(this.tableData, this.row_index, data);
          this.cancel();
          this.$hint("保存成功");
        } else {
          this.$hint("保存失败", "err");
        }
      });
    },
    // 删除数量
    delCompanyReq() {
      this.$http({
        url: this.$api.del_num + "/" + this.id,
        method: "get"
      }).then(res => {
        if (res.code == 0) {
          this.tableData.splice(this.row_index, 1);
          this.total--;
          this.$hint("删除成功");
        } else {
          this.$hint("删除失败", "err");
        }
      });
    },
    // 增加公司
    add() {
      this.title = "新增配置";
      this.dialogFormVisible = true;
      this.is_add = true;
      this.add_companyname = this.add_companyList[0].companyname || "";
      this.ruleForm = {
        classnum: "",
        eventexportnum: "",
        pagesize: "",
        interiorPageSize: "",
        principal_num: "5",
        companyid: this.add_companyList[0].companyid
      };
    },
    // 编辑数量
    handleEdit(index, row) {
      this.dialogFormVisible = true;
      this.title = row.companyname;
      if (!Boolean(this.title)) this.title = "编辑配置";
      this.row_index = index;
      this.ruleForm = JSON.parse(JSON.stringify(row));
      console.log(this.ruleForm);
      this.is_add = false;
    },
    // 点击删除
    handleDelete(index, row) {
      this.id = row.id;
      this.row_index = index;
    },
    // 确定删除
    confirmDelete() {
      this.delCompanyReq();
    },
    // 确定新增、编辑
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let item = JSON.parse(JSON.stringify(this.ruleForm));
          item.pageSize = Number(item.pagesize);
          if (this.is_add) {
            // 新增
            this.addNumReq(item);
          } else {
            // 编辑
            this.editNumReq(item);
          }
        } else {
          return false;
        }
      });
    },
    // 选择公司
    changeSelect(e) {
      this.ruleForm.companyid = e;
      this.add_companyList.forEach(val => {
        if (val.companyid == e) {
          this.add_companyname = val.companyname;
        }
      });
    },
    // 点击取消
    cancel() {
      this.dialogFormVisible = false;
      this.$refs.ruleForm.resetFields();
    }
  }
};
</script>

<style></style>
<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/pages/index/views/numAuthority.vue